module.exports = __webpack_public_path__ + "static/media/gren-min.e6e4eb92.png";